import { render } from "./_tabs.vue?vue&type=template&id=5310d913&lang=pug"
import script from "./_tabs.vue?vue&type=script&lang=js"
export * from "./_tabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__